export default __webpack_public_path__ + "static/media/errorXS.9f039512.webp";